export const links = [
    {
        name: 'Главная',
        href: '/',
    },
    {
        name: 'Купить косметику BTpeeL',
        href: '/vsja-produktsija',
    },
    {
        name: 'Акции',
        href: 'aktsii',
    },
    {
        name: 'Личный кабинет',
        href: '/my-account',
    },
    {
        name: 'Горячая линия 8 (499) 455-19-15',
        href: 'tel:84994551915',
    },
    {
        name: 'Условия возврата',
        href: '/dokumenty',
    },
]

export const links2 = [
    {
        name: 'Политика обработки персональных данных',
        href: '/politika-obrabotki-personalnyx-dannyx',
    },
    {
        name: 'Политика использования cookie',
        href: '/politika-ispolzovanija-cookie',
    }
]